var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    attrs: {
      "absolute": "absolute",
      "temporary": "temporary",
      "light": "light",
      "overflow": "overflow"
    },
    model: {
      value: (_vm.visibleDrawer),
      callback: function($$v) {
        _vm.visibleDrawer = $$v
      },
      expression: "visibleDrawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.currentUser !== null) ? _c('v-list-tile', {
    on: {
      "click": _vm.toChat
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("チャット")])], 1)], 1) : _vm._e(), (_vm.viewNewChatFlg === true) ? _c('v-list-tile', {
    on: {
      "click": _vm.toNewChat
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("新しいチャットを開始")])], 1)], 1) : _vm._e(), _c('v-divider')], 1)], 1), _c('v-toolbar', {
    staticClass: "white",
    attrs: {
      "dark": "dark",
      "fixed": "fixed"
    }
  }, [(_vm.enabledMenu) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.visibleDrawer = !_vm.visibleDrawer
      }
    }
  }) : _vm._e(), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _c('v-spacer'), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/user/static/logo.png"
    }
  })], 1), _c('div', {
    staticClass: "border"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fa64c7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = I8UB
// module chunks = 1